(function() {
	'use strict';

	angular.module('app.dashboard')
	.config(totalInventoryConfig);


	function totalInventoryConfig (dashboardProvider) {
		// register widget
		dashboardProvider.widget(
			'totalInventory', {
				name: 'Total Inventory',
				description: 'Displays a weekly history of inventory levels.',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/total-inventory.jpg',
				categories: ['All', 'Inventory'],
				config: {},
				slideshowView: true,
				isActive: true,
				controller: 'totalInventoryCtrl',
				templateUrl: '/application/f/dashboard/widgets/total-inventory.html',
				reload: true,
				isDrillDown: false
			}
		);
	}
})();
